import React, {useEffect} from 'react';

const Impressum = () => {
  useEffect(() => {
    const wrapper = document.querySelector('.scrollable');
    if (!wrapper) return;

    document.querySelector('.scrollable').addEventListener(
      'touchmove',
      function(event) {
        event.stopPropagation();
      },
      false,
    );
  });

  return (
    <>
      <div className="scrollable">
        <div className="profile-dataprotection">
          <div className="profile-text-container">
            <div className="profile-text-item">
              <b>Angaben gemäß § 5 TMG</b>        
            </div>
            <div className="profile-text-item">
              <b>aposphäre</b> <br />
              c/o IQVIA Commercial GmbH & Co. OHG <br />
              Clouth 104 <br />
              Niehler Str. 104 <br />
              50733 Köln
            </div>
            <div className="profile-text-item">
              <b>Kontakt:</b> <br />
              Telefon: +49 221 650 729 50 <br />
              E-Mail: info@aposphaere.de
            </div>
            <div className="profile-text-item">
              <b>Geschäftsführer:</b> <br />
              Dr. Frank Wartenberg (Vorsitzender), Karsten Immel
            </div>
            <div className="profile-text-item">
              <b>Registereintrag:</b> <br/>
              Registergericht: Frankfurt am Main HR A 29291            
            </div>
            <div className="profile-text-item">
              <b>Steuernummer:</b> <br />
              045/225/43506
            </div>
            <div className="profile-text-item">
              <b>Umsatzsteuer-Identifikationsnummer:</b> <br />
              gem. § 27a UStG: DE204958952
            </div>
            <div className="profile-text-item">
            <br />
              <b>Lieferkettensorgfaltspflichtengesetz:</b> <br />
              Für die aposphäre haben die Einhaltung und die Förderung der Menschenrechte sowie von Umweltstandards ebenso oberste Priorität wie ein höchstmögliches Maß an Arbeitssicherheit. Alle Informationen zum Lieferkettensorgfaltspflichtengesetz und zu unserer diesbezüglichen Unternehmenspolitk finden Sie  
              <a href='https://www.iqvia.com/de-de/locations/germany/impressum' target='_blank'> hier.</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Impressum;
